export function navigate(path: string, replace = false): void {
  if (replace) history.replaceState({}, '', path)
  else history.pushState({}, '', path)
  window.dispatchEvent(new PopStateEvent('popstate'))
}
